import { InjectionToken, Provider } from '@angular/core';

import {
  getAppLanguage,
  LANGUAGE,
  retrieveBrowserLanguage,
} from '../utils/internationalization';

export const APP_LOCALE_ID = new InjectionToken<LANGUAGE>('APP_LOCALE_ID');

export const provideLocaleId = (): Provider[] => [
  {
    provide: APP_LOCALE_ID,
    useFactory: (): LANGUAGE => getAppLanguage() ?? retrieveBrowserLanguage(),
    deps: [],
  },
];
